import React, { useEffect } from 'react';
import {
	Dialog,
	DialogActions,
	Button,
	DialogTitle,
	DialogContent,
	IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import checkIsMobile from 'utils/CheckIsMobile';
import 'assets/scss/info-modal.scss';
import { ButtonModal } from 'models/ButtonModal';
import { useControlModal } from 'hooks/useControlModal';
import { DATA_LAYERS } from 'constants/DataLayers';
import TagManager from 'react-gtm-module';

type OptionModalProps = {
	title: string;
	content: any;
	buttons: ButtonModal[];
	showCloseButton: boolean;
	dataLayerKey?: string;
};

export const OptionModal = ({
	title,
	content,
	buttons,
	showCloseButton,
	dataLayerKey,
}: OptionModalProps) => {
	const { open, handleClose } = useControlModal(true);

	const size = checkIsMobile() ? 'medium' : 'large';
	useEffect(
		() => {
			if (dataLayerKey) {
				TagManager.dataLayer({
					dataLayer: DATA_LAYERS.get(dataLayerKey),
				});
			}
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<Dialog open={open} onClose={handleClose} className="info-modal info-modal">
			<DialogTitle disableTypography className="info-modal-title title-4 primary-color">
				{title}
			</DialogTitle>
			{showCloseButton ? (
				<IconButton
					aria-label="close"
					style={{ position: 'absolute', top: 0, right: 0 }}
					onClick={handleClose}
				>
					<CloseIcon />
				</IconButton>
			) : null}
			<div className="info-modal-separador"></div>
			<DialogContent className="info-modal-content body gris-6">{content}</DialogContent>
			<DialogActions style={{ flexDirection: 'column' }}>
				{buttons.map((button, index) => {
					return (
						<Button
							key={index}
							size={size}
							variant={button.variant}
							color={button.color}
							onClick={() => {
								if (button.onClick) {
									button.onClick();
									if (button.onCloseFuntion) {
										handleClose();
									}
								} else {
									handleClose();
								}
							}}
							style={
								index === 0
									? { marginLeft: 0, minWidth: '200px' }
									: { marginLeft: 0, marginTop: 16 }
							}
						>
							{button.label}
						</Button>
					);
				})}
			</DialogActions>
		</Dialog>
	);
};
